import { g as getWindow } from './getWindow-JtVpfBBJ.js';

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

export { getComputedStyle as g };
//# sourceMappingURL=getComputedStyle-cPuW_mTw.js.map
